import React, { useEffect, useState } from "react";
import { useSearchParams, Link, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/AuthContext";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const navigate = useNavigate();
  const { reload } = useAuth();
  const [status, setStatus] = useState("verifying");
  const [detail, setDetail] = useState("");

  useEffect(() => {
    if (!token) { setStatus("missing"); return; }
    api.get(`/auth/verify-email?token=${encodeURIComponent(token)}`)
      .then(() => { setStatus("ok"); reload?.(); })
      .catch((e) => { setStatus("error"); setDetail(e?.response?.data?.detail || "Verification failed"); });
  }, [token, reload]);

  return (
    <div data-testid="page-verify-email" className="mx-auto max-w-md px-4 py-20 text-center">
      <div className="font-overline text-accent">Email Verification</div>
      {status === "verifying" && <h1 className="font-display text-3xl mt-3">Verifying your email…</h1>}
      {status === "ok" && (
        <>
          <h1 className="font-display text-3xl mt-3" data-testid="verify-success">Email verified</h1>
          <p className="text-muted-foreground mt-3 text-sm">Your account is now fully active. You can now create listings, submit offers, apply for loans, and pre-approve borrowers.</p>
          <Button onClick={() => navigate("/dashboard")} className="rounded-none uppercase text-xs tracking-wider mt-6" data-testid="verify-go-dashboard">Open My Dashboard</Button>
        </>
      )}
      {status === "error" && (
        <>
          <h1 className="font-display text-3xl mt-3 text-red-600" data-testid="verify-error">Verification failed</h1>
          <p className="text-muted-foreground mt-3 text-sm">{detail}</p>
          <p className="text-xs text-muted-foreground mt-4">Sign in and request a new verification email from your profile.</p>
          <Button asChild className="rounded-none uppercase text-xs tracking-wider mt-6"><Link to="/login">Sign In</Link></Button>
        </>
      )}
      {status === "missing" && (
        <>
          <h1 className="font-display text-3xl mt-3">Missing verification token</h1>
          <p className="text-muted-foreground mt-3 text-sm">Open the link directly from your inbox.</p>
        </>
      )}
    </div>
  );
}
